import React from "react";
import StatPill from "./StatPill";

type CoinsPillProps = {
  coins: number;   // 0 is allowed
};

const CoinsPill: React.FC<CoinsPillProps> = ({ coins }) => {
  return (
    <StatPill
      value={coins}
      label="Coins"
      valueClassName="text-yellow-500"
    />
  );
};

export default CoinsPill;
